import React from "react";

const InputCheckbox = (props) => {
  let invalidFields = props.invalidFields;
  return (
    <React.Fragment>
      <span
        className={
          invalidFields.includes(props.name)
            ? "checkbox-wrapper d-block position-relative invalid"
            : "checkbox-wrapper d-block position-relative"
        }
      >
        <input
          type="checkbox"
          name={props.name}
          value={props.value}
          checked={props.checked}
          onChange={props.onChange}
        />
        <span className="d-flex">
          <label>{props.value}</label>
        </span>
      </span>
    </React.Fragment>
  );
};

export default InputCheckbox;
